export default __webpack_public_path__ + "static/favicon-72a868da27989c905a4c38b1e8b753cd.png";